// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"991abae3","453":"88ad170e","455":"fd98c0f8"}[chunkId] + ".chunk.js";
};